import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_TEMPLATE,
  DELETE_TEMPLATE,
  GET_TEMPLATES,
  RENAME_TEMPLATE,
  CREATE_TEMPLATE_PDF,
  DELETE_TEMPLATE_PDF,
  GET_TEMPLATE_PDFS,
  RESET_TEMPLATE_EDIT_OVERLAY,
  SET_TEMPLATE_EDIT_OVERLAY,
  SET_TEMPLATE_LIST_VIEW,
  SET_TEMPLATE_OVERLAY,
  SET_TEMPLATE_OVERLAY_VIEW,
  RESET_TEMPLATE_EDIT_FORM,
  SET_TEMPLATE_EDIT_FORM,
  UPDATE_TEMPLATE
} from '../actions';

const initialTemplateListViewState = {
  error      : <string>'',
  loading    : <boolean>false,
  overlayFile: <Object>{ key: <string>'', url: <string>null }
};

const initialTemplateOverlayViewState = {
  deleteKey    : <string>'',
  loading      : <boolean>false,
  pdfsLoading  : <boolean>false,
  ignoreChanges: <boolean>false
};

const initialEditFormState = {
  id            : <string>'',
  name          : <string>'',
  editExisting  : <boolean>false,
  ignoreChanges : <boolean>false,
  loading       : <boolean>false,
  templateHeader: <string>'',
  submitted     : <boolean>false,
  overlayFile   : <Object>{ key: <string>'', url: <string>null },
  pdfsLoading   : <boolean>false
};

export function templateListViewReducer(state = initialTemplateListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialTemplateListViewState);
    case SET_TEMPLATE_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    case SET_TEMPLATE_OVERLAY:
      return Object.assign({}, state, {
        overlayFile: action.payload.overlayFile
      });
    default:
      return state;
  }
}

export function templatesListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_TEMPLATE:
      const match = state.find(template => action.payload.template && template.id === action.payload.template.id);
      return !match
        ? [ ...state, action.payload.template ].sort(sortTemplates)
        : state;
    case DELETE_TEMPLATE:
      return state.filter(template => template.id !== action.payload.id);
    case GET_TEMPLATES:
      return [ ...action.payload.templates ].sort(sortTemplates);
    case UPDATE_TEMPLATE:
      return state.map(template => {
        return template.id === action.payload.template.id
          ? action.payload.template
          : template;
      });
    default:
      return state;
  }
}

export function templateOverlayViewReducer(state = initialTemplateOverlayViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialTemplateOverlayViewState);
    case SET_TEMPLATE_OVERLAY_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function templatePDFListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_TEMPLATE_PDF:
      return [ ...state, action.payload.pdf ].sort(sortTemplatePDFs);
    case DELETE_TEMPLATE_PDF:
      return state.filter(pdf => pdf.key !== action.payload.key);
    case GET_TEMPLATE_PDFS:
      return [ ...action.payload.pdfs ].sort(sortTemplatePDFs);
    default:
      return state;
  }
}

export function templateEditFormReducer(state = initialEditFormState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialEditFormState);
    case RESET_TEMPLATE_EDIT_OVERLAY:
      return Object.assign({}, state, {
        overlayFile: initialEditFormState.overlayFile
      });
    case SET_TEMPLATE_EDIT_OVERLAY:
      return Object.assign({}, state, {
        overlayFile: action.payload.overlayFile
      });
    case RESET_TEMPLATE_EDIT_FORM:
      return Object.assign({}, state, initialEditFormState);
    case SET_TEMPLATE_EDIT_FORM:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

function sortTemplates(template1, template2): number {
  const template1Name = (template1.templateName || '').toLowerCase();
  const template2Name = (template2.templateName || '').toLowerCase();

  if (template1Name < template2Name) return -1;
  else if (template1Name > template2Name) return 1;
  else return 0;
}

function sortTemplatePDFs(pdf1, pdf2): number {
  const pdf1Name = (pdf1.key || '').toLowerCase();
  const pdf2Name = (pdf2.key || '').toLowerCase();

  if (pdf1Name < pdf2Name) return -1;
  else if (pdf1Name > pdf2Name) return 1;
  else return 0;
}

export const templateReducers = combineReducers({
  templateEditForm: templateEditFormReducer,
  templateOverlayView: templateOverlayViewReducer,
  templateList: templatesListReducer,
  templateListView: templateListViewReducer,
  templatePDFList: templatePDFListReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/templates.ts